import ContainerWithStickyLabel from './ContainerWithStickyLabel';

export default ContainerWithStickyLabel;
